<template>
	<div
		class="view view-error"
	>
		<banner />

		<div
			class="main-content main-content--max-width main-content--spaced-top"
		>
			<div class="container">
				<h1 class="content-title">Sorry, we are currently experiencing technical difficulties.</h1>

				<hr class="hr--small" />

				<div class="introduction">
					Please refresh the page or try again later.
				</div>

			</div>

		</div>

	</div>
</template>

<script>
// Components
import Banner from '@/components/blocks/Banner.vue';

export default {
	components: {
		Banner
	},
	watch: {
		// Reset state when route changed
		$route() {
			this.$store.commit('apiError', false);
		}
	},
};
</script>